export const COMPLAINT_FILE_UPLOAD_SIZE_LIMIT = 5 * 1024 * 1024 // 5MB
export const COMPLAINT_FILE_UPLOAD_AMOUNT_LIMIT = 15
export const MAX_COMPLAINT_CHARACTERS = 4_000
